module.exports = __webpack_public_path__ + "media/images/flags/HR-3ef2af627eee516a2c2cc1c5d45e17ee.svg";